import { render, staticRenderFns } from "./generarExcel.vue?vue&type=template&id=7cb3a2c0&scoped=true"
import script from "./generarExcel.vue?vue&type=script&lang=js"
export * from "./generarExcel.vue?vue&type=script&lang=js"
import style0 from "./generarExcel.vue?vue&type=style&index=0&id=7cb3a2c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb3a2c0",
  null
  
)

export default component.exports